import * as React from 'react';
import { FieldError } from 'react-hook-form';
import { JRCTypography } from '../../../JRCTypography/JRCTypography';
import styled from 'styled-components';

const Error = styled(JRCTypography).attrs(() => ({ size: 's' }))`
    color: ${(props) => props.theme.color.orange};
`;

/**
 * Component that displays a list of input error if any.
 * The required message is not displayed within this component.
 * @param error react-hook-form object
 */
export const JRCFormErrors = ({ error }: { error?: FieldError }) => {
    const errors =
        error &&
        error?.types &&
        Object.entries(error.types)
            .filter(([k]) => k !== 'required')
            .map(([, v]) => v);

    return (
        <>
            {errors?.map((err, index) => {
                return <Error key={index}>{err}</Error>;
            })}
        </>
    );
};
